import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { S_Alert } from '../../../../design/alert/S_Alert';
import { S_Link } from '../../../../design/links/S_Link';
import { IProjectOverviewBl } from '../../../../modules/projects/project/overview/projectOverview.bl';
import { Home } from '../../../routes/config/Home';

export const ProjectDetailsGlobalErrorsContainer = observer((): ReactElement => {
  const bl = useInjection(IProjectOverviewBl.$);
  const { t } = useTranslator();
  const params = useParams<{ projectId: string; workspaceId: string }>();

  return (
    <>
      {bl.store.publishMoreDatasets && (
        <S_Alert color='danger'>
          <S_Link
            color='text'
            to={Home.Projects.Details.Datasets.withParams(params)}
          >
            {t('publish_more_datasets')}
          </S_Link>
        </S_Alert>
      )}
    </>
  );
});
